import { TransversalBar } from '../../components/pagesComponents/transversalBar'
import { RegisterDatasPersonContent } from '../../components/pagesComponents/registerDatasPersonPage';

import { Container } from './style';

export function RegisterDatasPerson() {
    return(
        <Container>
            <TransversalBar />
            <RegisterDatasPersonContent />
        </Container>
    )
}
